function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Form - Info component
 * 
 */

import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Info.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Info extends React.Component {
  render() {
    if (this.props.info.length === 0) {
      return null;
    }
    const frame_class = this.props.framed ? 'framed' : '';
    return /*#__PURE__*/_jsxs("div", {
      className: 'info ' + frame_class,
      children: [this.props.icon.length > 0 && /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: this.props.icon
      }), /*#__PURE__*/_jsx("p", {
        dangerouslySetInnerHTML: {
          __html: this.props.info
        }
      })]
    });
  }
}
_defineProperty(Info, "defaultProps", {
  info: '',
  icon: '',
  framed: false
});
export default Info;